import {includes, values} from 'lodash';
import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {Radio} from 'components';
import {TRANSLATION_KEYS} from 'locale/translation-keys';
import {ParticipantRole} from 'types';

const T_KEYS = TRANSLATION_KEYS.COMMON.SESSION.LABELS;

type Props = {
    guestEnabled?: boolean;
    assistantEnabled?: boolean;
    role: ParticipantRole,
    roles?: ParticipantRole[],
    disabled?: boolean;
    className?: string;
    hideDisabledRoles?: boolean;
    onChange: (role: ParticipantRole) => void;
}

export const SessionParticipantRoleSelector = ({
    role, roles = values(ParticipantRole), disabled, className, guestEnabled, assistantEnabled,
    hideDisabledRoles, onChange
}: Props) => {
    const {t} = useTranslation();

    const handleChange = useCallback((id: ParticipantRole) => onChange(id), [onChange]);

    const shouldHideRole = useCallback((selectorRole: ParticipantRole) => {
        const roleDisabled = disabled || !includes(roles, selectorRole);
        return roleDisabled && hideDisabledRoles;
    }, [disabled, roles, hideDisabledRoles]);

    return (
        <div className={className}>
            {!shouldHideRole(ParticipantRole.Agent) && <Radio
                id='participant-agent'
                name='selected-role'
                labelPlacement='left'
                className='tw-mr-4'
                label={t(T_KEYS.AGENT)}
                checked={role === ParticipantRole.Agent}
                value={ParticipantRole.Agent}
                disabled={disabled || !includes(roles, ParticipantRole.Agent)}
                onSelect={handleChange}
            />}

            {assistantEnabled && !shouldHideRole(ParticipantRole.Assistant) && <Radio
                id='participant-assistant'
                name='selected-role'
                labelPlacement='left'
                className='tw-mr-4'
                label={t(T_KEYS.ASSISTANT)}
                checked={role === ParticipantRole.Assistant}
                value={ParticipantRole.Assistant}
                disabled={disabled || !includes(roles, ParticipantRole.Assistant)}
                onSelect={handleChange}
            />}

            {!shouldHideRole(ParticipantRole.Client) && <Radio
                id='participant-client'
                name='selected-role'
                labelPlacement='left'
                className='tw-mr-4'
                label={t(T_KEYS.CLIENT)}
                checked={role === ParticipantRole.Client}
                value={ParticipantRole.Client}
                disabled={disabled || !includes(roles, ParticipantRole.Client)}
                onSelect={handleChange}
            />}

            {guestEnabled && !shouldHideRole(ParticipantRole.Guest) &&
                <Radio
                    id='participant-guest'
                    name='selected-role'
                    labelPlacement='left'
                    className='tw-mr-4'
                    label={t(T_KEYS.GUEST)}
                    checked={role === ParticipantRole.Guest}
                    value={ParticipantRole.Guest}
                    disabled={disabled || !includes(roles, ParticipantRole.Guest)}
                    onSelect={handleChange}
                />}
        </div>
    );
};